import React, { Component } from 'react';
import { withRouter, Link } from "react-router-dom";
import moment from 'moment';

import AlertsModel from './components/AlertsModel';
import UserModel from './components/UserModel';
import UserChangePasswordForm from './components/UserChangePasswordForm';

import './MainLayout.css';

import { Layout, Menu, Icon, message, notification } from 'antd';

const { Header, Footer, Sider } = Layout;

class App extends Component {

  state = {
    showedModal: null,
    isSiderCollapsed: false
  }

  async componentDidMount() {
    setInterval(async () => {
      try {
        let unreportedAlerts = await AlertsModel.getUnreportedLastMinute();
        if (unreportedAlerts.length > 0) {
          let nKey = 'n' + Date.now();
          notification['info']({
            key: nKey,
            message: 'Nové upozornění',
            description: 'Bylo vytvořeno nové upozornění, které ještě nebylo reportováno!',
            duration: 60,
            onClick: () => {
              notification.close(nKey);
              this.props.history.push('/alerts/all');
            }
          });
        }
      } catch (err) {
        // if (err.response.status === 401) {
        //   UserModel.logout();
        //   this.props.history.push('/login');
        // }
      }
    }, 60000)
  }

  onHeaderMenuClick(e) {
    if (e.key === 'logout') {
      UserModel.logout();
      this.props.history.push('/');
    }

    if (e.key === 'changePassword') {
      this.setState({
        showedModal: 'changePassword'
      });
    }
  }

  toggleSider() {
    this.setState({
      isSiderCollapsed: !this.state.isSiderCollapsed,
    });
  }

  render() {
    const menuItems = [{
      title: 'Přehled',
      icon: 'home',
      link: '/'
    }, {
      title: 'Přehledová mapa',
      icon: 'environment',
      external: '/overview.html',
      target: '_blank'
    }, {
      title: 'Kontrola PO',
      icon: 'check',
      roles: ['ADMIN', 'CHECKER_PARKINGS', 'CHECKER_OFFENSES_READ', 'CHECKER_SETTINGS'],
      subItems: [{
        title: 'Seznam PO',
        link: '/checking/parkings',
        roles: ['ADMIN', 'CHECKER_PARKINGS']
      }, {
        title: 'Provedené kontroly',
        link: '/checking/offenses',
        roles: ['ADMIN', 'CHECKER_OFFENSES_READ']
      }, {
        title: 'Nastavení',
        link: '/checking/settings',
        roles: ['ADMIN', 'CHECKER_SETTINGS']
      }]
    }, {
      title: 'Park-Detect',
      icon: 'car',
      roles: ['ADMIN', 'PARKDETECT_DETECTIONS_READ', 'PARKDETECT_ZONEDETECTIONS_READ', 'PARKDETECT_PARKINGLOCATIONS_READ'],
      subItems: [{
        title: 'Detekované RZ',
        link: '/parkdetect/detekce',
        roles: ['ADMIN', 'PARKDETECT_DETECTIONS_READ']
      }, {
        title: 'Detekované zóny',
        link: '/parkdetect/detekce-zon',
        roles: ['ADMIN', 'PARKDETECT_ZONEDETECTIONS_READ']
      }, {
        title: 'Seznam lokalit',
        link: '/parkdetect/parkinglocations',
        roles: ['ADMIN', 'PARKDETECT_PARKINGLOCATIONS_READ']
      }]
    }, {
      title: 'MKA',
      icon: 'camera',
      roles: ['ADMIN', 'MKA_DETECTIONS_READ'],
      subItems: [{
        title: 'Detekované RZ',
        link: '/mka/detekce',
        roles: ['ADMIN', 'MKA_DETECTIONS_READ']
      }]
    }, {
      title: 'MPA',
      icon: 'mobile',
      roles: ['ADMIN', 'MPA_PARKINGLOCATIONS_READ'],
      subItems: [{
        title: 'Seznam lokalit',
        link: '/mpa/parkinglocations',
        roles: ['ADMIN', 'MPA_PARKINGLOCATIONS_READ']
      }]
    }, {
      title: 'EPO',
      icon: 'profile',
      roles: ['ADMIN', 'EPO_PARKINGLOCATIONS_READ'],
      subItems: [{
        title: 'Seznam lokalit',
        link: '/epo/parkinglocations',
        roles: ['ADMIN', 'EPO_PARKINGLOCATIONS_READ']
      }]
    }, {
      title: 'Parkeon',
      icon: 'dashboard',
      roles: ['ADMIN', 'PARKEON_PARKINGLOCATIONS_READ'],
      subItems: [{
        title: 'Seznam lokalit',
        link: '/parkeon/parkinglocations',
        roles: ['ADMIN', 'PARKEON_PARKINGLOCATIONS_READ']
      }]
    }, {
      title: 'Informační tabule',
      icon: 'info',
      roles: ['ADMIN', 'TRAFFICSIGNS_READ', 'TRAFFICSIGNS_LOGS_READ'],
      subItems: [{
        title: 'Seznam tabulí',
        link: '/trafficsigns/list',
        roles: ['ADMIN', 'TRAFFICSIGNS_READ']
      }, {
        title: 'Stavy',
        link: '/trafficsigns/states',
        roles: ['ADMIN', 'TRAFFICSIGNS_STATES_READ']
      }, {
        title: 'Informace',
        link: '/trafficsigns/infos',
        roles: ['ADMIN', 'TRAFFICSIGNS_INFOS_READ']
      }, {
        title: 'Zprávy',
        link: '/trafficsigns/messages',
        roles: ['ADMIN', 'TRAFFICSIGNS_MESSAGES_READ']
      }, {
        title: 'Logy',
        link: '/trafficsigns/logs',
        roles: ['ADMIN', 'TRAFFICSIGNS_LOGS_READ']
      }]
    }, {
      title: 'Časovače',
      icon: 'clock-circle',
      roles: ['ADMIN', 'TIMEOUTSIGNS_READ'],
      subItems: [{
        title: 'Seznam časovačů',
        link: '/timeoutsigns/list',
        roles: ['ADMIN', 'TIMEOUTSIGNS_READ']
      }]
    }, {
      title: 'TinyNode',
      icon: 'up-circle',
      roles: ['ADMIN', 'TINYNODE_PARKINGLOCATIONS_READ', 'TINYNODE_SENSORS_READ', 'TINYNODE_INFRASTRUCTURES_READ', 'TINYNODE_MESSAGES_READ', 'TINYNODE_DATA_READ'],
      subItems: [{
        title: 'Senzory',
        link: '/tinynode/sensors',
        roles: ['ADMIN', 'TINYNODE_SENSORS_READ']
      }, {
        title: 'Infrastruktura',
        link: '/tinynode/infrastructures',
        roles: ['ADMIN', 'TINYNODE_INFRASTRUCTURES_READ']
      }, {
        title: 'Zprávy',
        link: '/tinynode/messages',
        roles: ['ADMIN', 'TINYNODE_MESSAGES_READ']
      }, {
        title: 'Data',
        link: '/tinynode/data',
        roles: ['ADMIN', 'TINYNODE_DATA_READ']
      }, {
        title: 'Maintenance',
        link: '/tinynode/maintenance',
        roles: ['ADMIN', 'TINYNODE_MAINTENANCE_READ']
      }, {
        title: 'Seznam lokalit',
        link: '/tinynode/parkinglocations',
        roles: ['ADMIN', 'TINYNODE_PARKINGLOCATIONS_READ']
      }]
    }, {
      title: 'Urbiotica',
      icon: 'down-circle',
      roles: ['ADMIN', 'URBIOTICA_PARKINGLOCATIONS_READ', 'URBIOTICA_SENSORS_READ', 'URBIOTICA_MESSAGES_READ', 'URBIOTICA_TECHINFO_READ'],
      subItems: [{
        title: 'Senzory',
        link: '/urbiotica/sensors',
        roles: ['ADMIN', 'URBIOTICA_SENSORS_READ']
      }, {
        title: 'Zprávy o obsazenosti',
        link: '/urbiotica/messages',
        roles: ['ADMIN', 'URBIOTICA_MESSAGES_READ']
      }, {
        title: 'Technologické zprávy',
        link: '/urbiotica/techmessages',
        roles: ['ADMIN', 'URBIOTICA_TECHINFO_READ']
      }, {
        title: 'Seznam lokalit',
        link: '/urbiotica/parkinglocations',
        roles: ['ADMIN', 'URBIOTICA_PARKINGLOCATIONS_READ']
      }]
    }, {
      title: 'Kamerová detekce',
      icon: 'video-camera',
      roles: ['ADMIN', 'CAMDETECT_PARKINGLOCATIONS_READ', 'CAMDETECT_CAMERAS_READ', 'CAMDETECT_ERRORS_READ', 'CAMDETECT_TECHDATAS_READ'],
      subItems: [{
        title: 'Kamery',
        link: '/camdetect/cameras',
        roles: ['ADMIN', 'CAMDETECT_CAMERAS_READ']
      }, {
        title: 'Technologické zprávy',
        link: '/camdetect/techdatas',
        roles: ['ADMIN', 'CAMDETECT_TECHDATAS_READ']
      }, {
        title: 'Chyby',
        link: '/camdetect/errors',
        roles: ['ADMIN', 'CAMDETECT_ERRORS_READ']
      }, {
        title: 'Seznam lokalit',
        link: '/camdetect/parkinglocations',
        roles: ['ADMIN', 'CAMDETECT_PARKINGLOCATIONS_READ']
      }]
    }, {
      title: 'Upozornění',
      icon: 'warning',
      roles: ['ADMIN', 'CORE_ALERTS_READ'],
      subItems: [{
        title: 'Všechny upozornění',
        link: '/alerts/all',
        roles: ['ADMIN', 'CORE_ALERTS_READ']
      }]
    }, {
      title: 'Systém',
      icon: 'setting',
      roles: ['ADMIN', 'CORE_PARKINGLOCATIONS_READ', 'CORE_PARKINGLOCATIONS_PLACES_READ', 'CORE_PLACEROLES_READ', 'CORE_USERS_READ', 'CORE_SERVICES_READ'],
      subItems: [{
        title: 'Lokality',
        link: '/settings/parkinglocations',
        roles: ['ADMIN', 'CORE_PARKINGLOCATIONS_READ']
      }, {
        title: 'Parkovací místa',
        link: '/settings/parkinglocation-places',
        roles: ['ADMIN', 'CORE_PARKINGLOCATIONS_PLACES_READ']
      }, {
        title: 'Role parkovacích míst',
        link: '/settings/place-roles',
        roles: ['ADMIN', 'CORE_PLACEROLES_READ']
      }, {
        title: 'Skupiny lokalit',
        link: '/settings/parkinglocation-groups',
        roles: ['ADMIN', 'CORE_PARKINGLOCATIONSGROUPS_READ']
      }, {
        title: 'Uživatelé',
        link: '/settings/users',
        roles: ['ADMIN', 'CORE_USERS_READ']
      }, {
        title: 'Služby',
        link: '/settings/services',
        roles: ['ADMIN', 'CORE_SERVICES_READ']
      }]
    }];

    return (
      <Layout style={{ height: "100vh" }}>
        <Sider
          className="cstm-scrollbar"
          breakpoint="xl"
          width={235}
          collapsedWidth={80}
          trigger={null}
          onCollapse={(collapsed) => {
            this.setState({
              isSiderCollapsed: collapsed
            });
          }}
          style={{
            overflow: 'auto',
            height: '100vh',
            position: 'fixed',
            left: 0,
            zIndex: 9999
          }} >
          {this.state.isSiderCollapsed
            ? <div className="logo" style={{ width: 41, height: 32, background: 'url("https://smart4city.cz/img/s4c_logo_32_1.png")', margin: 16, marginLeft: 19 }} />
            : <div className="logo" style={{ width: 160, height: 32, background: 'url("https://smart4city.cz/img/s4c_logo_32.png")', margin: 16, marginLeft: 34 }} />}
          <Menu theme="dark" mode="inline" defaultSelectedKeys={['/']} selectedKeys={[this.props.location.pathname]}>
            {menuItems.map((menuItem, midx) => {
              if (menuItem.subItems !== undefined && UserModel.isInRoles(menuItem.roles)) {
                return (
                  <Menu.SubMenu
                    key={midx}
                    title={
                      <div>
                        {menuItem.icon
                          ? <Icon type={menuItem.icon} />
                          : null}
                        <span>
                          {menuItem.title}
                        </span>
                      </div>
                    } >
                    {
                      menuItem.subItems.map((subItem, sidx) => {
                        if (UserModel.isInRoles(subItem.roles)) {
                          return (
                            <Menu.Item key={/*midx + '-' + sidx*/subItem.link}>
                              <Link to={subItem.link}>
                                <span className="nav-text">{subItem.title}</span>
                              </Link>
                            </Menu.Item>
                          );
                        }
                      })
                    }
                  </Menu.SubMenu>
                );
              } else {
                if (menuItem.roles === undefined || UserModel.isInRoles(menuItem.roles)) {
                  return (
                    <Menu.Item key={midx}>
                      {menuItem.link === undefined && menuItem.external
                        ? <a target={menuItem.target} href={menuItem.external}>
                          {
                            <span>
                              {menuItem.icon
                                ? <Icon type={menuItem.icon} />
                                : null}
                              <span>
                                {menuItem.title}
                              </span>
                            </span>
                          }
                        </a>
                        : <Link to={menuItem.link}>
                          {
                            <span>
                              {menuItem.icon
                                ? <Icon type={menuItem.icon} />
                                : null}
                              <span>
                                {menuItem.title}
                              </span>
                            </span>
                          }
                        </Link>}
                    </Menu.Item>
                  );
                }
              }
            })}
          </Menu>
        </Sider>
        <Layout style={{ marginLeft: this.state.isSiderCollapsed ? 80 : 235 }}>
          <Header style={{ background: '#fff', padding: 0, height: 47 }} >
            <Menu mode="horizontal" onClick={this.onHeaderMenuClick.bind(this)}>
              <Menu.SubMenu
                style={{
                  float: 'right'
                }}
                title={<span>
                  <Icon type="user" />
                  {UserModel.getName()}
                </span>} >
                <Menu.Item key="changePassword">
                  Změnit heslo
                </Menu.Item>
                <Menu.Item key="logout">
                  Odhlásit se
                </Menu.Item>
              </Menu.SubMenu>
            </Menu>
          </Header>

          <UserChangePasswordForm
            type='modal'
            modalVisible={this.state.showedModal && this.state.showedModal === 'changePassword'}
            onModalCancel={() => {
              this.setState({
                showedModal: null
              });
            }}
            onSuccess={(form, values) => {
              UserModel.changePassword(values.oldPassword, values.newPassword)
                .then((msg) => {
                  form.resetFields();
                  message.success(msg);
                })
                .catch((msg) => {
                  message.error(msg);
                });
            }} />

          {this.props.children}

          <Footer style={{ textAlign: 'center' }}>
            Smart4City ©{moment().format('YYYY')} Created by SPEL a.s.
          </Footer>
        </Layout>
      </Layout>
    );
  }
}

export default withRouter(App);



// WEBPACK FOOTER //
// ./src/MainLayout.js